export namespace Samples {

  export interface Sample<T> {
    id: string
    deviceId: string
    instant: string
    capability: string
    value: T
  }

  export interface SampleValue<T> {
    instant: string,
    value: T
  }

  export interface AssetSample<T> {
    assetId: string
    sample: Sample<T>
    alertStatus?: AlertStatus
    alertStatusCount?: number
  }

  export enum AlertStatus {
    NONE = "NONE",
    STOPPED_MOVING = "STOPPED_MOVING",
    ABNORMALLY_LOW_ACTIVITY = "ABNORMALLY_LOW_ACTIVITY",
    ABNORMALLY_HIGH_ACTIVITY = "ABNORMALLY_HIGH_ACTIVITY",
    OUT_OF_PADDOCK = "OUT_OF_PADDOCK",
    OUT_OF_FARM = "OUT_OF_FARM",
    HIGH_ALERT = "HIGH_ALERT",
    HIGH_WARNING = "HIGH_WARNING",
    LOW_WARNING = "LOW_WARNING",
    LOW_ALERT = "LOW_ALERT",
    LOW_BATTERY = "LOW_BATTERY"
  }

  export interface GPSFix {
    position?: Position
    accuracy?: number
    timeToFix?: number
    numberOfSatellites?: number
    source?: string
    extents?: {
      rings?: number[][]
      srid?: number
    }
  }

  export interface NfcGpsFix {
    position: Position
    hdop: number
    fixQuality: number
    timeToFirstFix: number
    messageCounter: number
  }

  export interface Position {
    coords?: number[]
    srid?: number
  }

  export interface PrecipitationSample {
    amount: number,
    accumulated: number,
    period: number
  }

  export interface ProximitySample {
    serial: string,
    rssi: number
  }

  export interface AccelerationCount {
    secondsSinceLastInterrupt: number;
    numberOfInterrupts: number;
  }

  export interface DeviceHeartbeat {
    uptimeSeconds: number;
    basicPacketsSent: number;
    gpsPacketsSent: number;
  }

  export interface NfcLocationSampleMetadata {
    id: string,
     userId: string,
     scannedAt: Date,
     postedAt: Date,
    scanningDevice: string,
    failedScan: boolean,
    sampleCount: number,
    discrepancyReason: string,
    samples: Samples.Sample<Samples.NfcGpsFix>[]
  }
}
